export class Network  {

    Id: number;
    Title: string;
    ForeignTitle: string;
    Status: boolean;
    
    constructor() { }
}